<template>
  <div>
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="650"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          flat
          height="80"
          max-height="80"
        >
          <v-avatar
            color="blue"
            size="46"
          >
            <v-icon
              color="white"
              size="30"
            >
              {{ $t('Payment.Dialog.ResendAll.Toolbar.Icon') }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ $t('Payment.Dialog.ResendAll.Toolbar.Title') }}
            </div>
            <div class="text-caption">
              {{ $t('Payment.Dialog.ResendAll.Toolbar.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text class="pa-0">
          <v-container fluid>
            <v-row dense>
              <template v-for="vendor in vendors">
                <template v-for="terminal in vendor.Terminals">
                  <template v-if="terminal.Active">
                    <v-col
                      :key="`vendor-${vendor.Id}-terminal-${terminal.Id}-no-instalments`"
                      cols="12"
                    >
                      <v-list class="pa-0">
                        <v-list-item
                          :class="isDarkMode ? 'grey darken-3' : 'grey lighten-3'"
                          class="rounded rounded-r-0 px-1 px-sm-3"
                          ripple
                          @click="onSelectTerminal(terminal)"
                        >
                          <v-list-item-avatar
                            class="mr-1 mr-sm-3"
                            size="32"
                          >
                            <v-icon
                              color="green"
                              size="32"
                            >
                              mdi-credit-card-wireless
                            </v-icon>
                          </v-list-item-avatar>

                          <v-list-item-content :class="isDarkMode ? 'white--text' : 'grey--text text--darken-2'">
                            <v-list-item-title class="text-left">
                              {{ terminal.Nickname }} <span class="grey--text">[{{ terminal.TerminalId }}]</span>
                            </v-list-item-title>

                            <v-list-item-subtitle class="text-caption">
                              {{ getVendorAcquirerTextById(vendor.Id, terminal.AcquirerCode) }}
                            </v-list-item-subtitle>

                            <v-list-item-subtitle class="text-caption">
                              {{ terminal.Manufactor }} - {{ terminal.Model }}
                            </v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-icon
                              color="blue"
                              large
                            >
                              mdi-invoice-text-send-outline
                            </v-icon>
                          </v-list-item-action>
                        </v-list-item>
                      </v-list>
                    </v-col>
                  </template>
                </template>
              </template>

              <v-col cols="12">
                <v-alert
                  v-if="successMessage"
                  border="left"
                  class="mb-0 text-capitalize text-caption"
                  dense
                  type="success"
                >
                  {{ successMessage }}
                </v-alert>

                <v-alert
                  v-if="errorMessage"
                  border="left"
                  class="mb-0 text-capitalize text-caption"
                  dense
                  type="error"
                >
                  {{ errorMessage }}
                </v-alert>
              </v-col>

              <v-overlay
                :value="isLoading"
                absolute
                z-index="0"
              >
                <v-progress-circular
                  indeterminate
                  size="64"
                />
              </v-overlay>
            </v-row>
          </v-container>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn
            class="light-blue--text text--darken-1"
            outlined
            text
            @click="onCancelButtonClick"
          >
            {{ $t('Common.Button.Close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import AppData from '@/mixins/appdata'
import TerminalsCommon from '@/mixins/payments/terminalsCommon'

export default {
  name      : 'PaymentTerminalsSendAllDialog',
  components: {},
  mixins    : [AppData, TerminalsCommon],
  props     : {
    visible: {
      type   : Boolean,
      default: false
    },

    vendor: {
      type   : String,
      default: ''
    }
  },
  data() {
    return {
      isLoading     : false,
      successMessage: '',
      errorMessage  : ''
    }
  },
  computed: {
    vendors() {
      const vendors = this.appConfig?.POS_VENDORS || []
      return vendors.filter(vendor => vendor.Code === this.vendor)
    },

    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch  : {},
  methods: {
    onSelectTerminal(terminal) {
      this.successMessage = ''
      this.errorMessage = ''

      this.terminalResendAll(terminal)
    },

    terminalResendAll(terminal) {
      this.isLoading = true
      this.$bus.$once(window.SocketCommand.Payment.EftPos.ResendAll, this.onTerminalResendAllResponse)

      window.callAS(window.SocketCommand.Payment.EftPos.ResendAll, {
        VendorId  : terminal.PosVendorId,
        TerminalId: terminal.TerminalId
      }, window.SocketCommand.Payment.EftPos.ResendAll, 60000)
    },
    onTerminalResendAllResponse(data, payload) {
      this.isLoading = false

      if (data?.error && data?.message) {
        this.errorMessage = data.message
        payload = data?.payload
      } else if (data?.error) {
        this.errorMessage = data.error
      } else if (data?.processed_transactions) {
        this.successMessage = this.$t('Payment.Dialog.ResendAll.Message.ProcessedTransactions', {ProcessedTransactions: data.processed_transactions})
      }
    },

    onCancelButtonClick() {
      this.isVisible = false
      this.isLoading = false
      this.successMessage = ''
      this.errorMessage = ''
      this.$bus.$off(window.SocketCommand.Payment.EftPos.ResendAll, this.onTerminalResendAllResponse)
    }
  }
}
</script>
